export const SIDEBAR_CONTENT = [
  {
    title: 'Сдайте квартиру без хлопот – сделаем все за вас',
    list: [
      {
        image: 'tag',
        text: 'Поможем определить оптимальную стоимость аренды',
      },
      {
        image: 'camera',
        text: 'Сделаем фотосъемку квартиры, установим оборудование для показов',
      },
      {
        image: 'rocket',
        text: 'Разместим объявление и продвинем его',
      },
    ],
  },
  {
    title: 'Сдайте квартиру безопасно надежным жильцам',
    list: [
      {
        text: 'Проведем показы квартиры, ваше присутствие не потребуется, мы проконтролируем процесс удаленно. За просмотрами вы сможете наблюдать в личном кабинете',
        image: 'star',
      },
      {
        text: 'Подберем и проверим арендаторов на благонадежность, вам останется выбрать подходящего',
        image: 'human',
      },
      {
        text: 'Застрахуем имущество от непредвиденных ситуаций и простоя квартиры',
        image: 'shield',
      },
    ],
  },
  {
    title: 'Останемся рядом даже после сдачи',
    list: [
      {
        text: 'Всегда будем на связи и поможем в решении бытовых и спорных вопросов',
        image: 'rocket',
      },
      {
        text: 'Если жилец неожиданно съедет, примем квартиру и оперативно найдем нового',
        image: 'human',
      },
    ],
  },
];
